import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/SEOHead';
import PublicLayout from '@/components/layout/PublicLayout';

export default function MentionsLegales() {
 return (
 <PublicLayout>
 <SEOHead
        title="Mentions Légales | Clairify"
        description="Mentions légales de Clairify. Informations sur l'éditeur, l'hébergeur, et les responsabilités légales."
        keywords={['mentions légales', 'informations légales', 'éditeur', 'hébergeur']}
        canonicalUrl="https://clairify.fr/mentions-legales"
        ogType="website"
      />
 <article className="legal-doc">
 <p className="home-kicker">Légal</p>
 <h1 className="text-4xl font-bold text-theme-primary mb-8">Mentions Légales</h1>
 
 <div className="space-y-8 text-theme-secondary leading-relaxed">
 {/* Éditeur */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">1. Éditeur du site</h2>
 <div className="space-y-2 bg-theme-surface/50 p-6 rounded-xl border border-theme-border">
 <p><strong className="text-theme-primary">Raison sociale :</strong> STELLARMEET</p>
 <p><strong className="text-theme-primary">Forme juridique :</strong> SAS (Société par Actions Simplifiée)</p>
 <p><strong className="text-theme-primary">Capital social :</strong> 1 000,00 € (fixe)</p>
 <p><strong className="text-theme-primary">SIREN :</strong> 935 065 094</p>
 <p><strong className="text-theme-primary">SIRET :</strong> 935 065 094 00010</p>
 <p><strong className="text-theme-primary">N° TVA Intracommunautaire :</strong> FR11 935 065 094</p>
 <p><strong className="text-theme-primary">Code NAF/APE :</strong> 62.01Z - Programmation informatique</p>
 <p><strong className="text-theme-primary">Date de création :</strong> 30 octobre 2024</p>
 <p><strong className="text-theme-primary">Siège social :</strong> 25 rue de Ponthieu, 75008 Paris, France</p>
 <p><strong className="text-theme-primary">RNE :</strong> Immatriculée au Registre National des Entreprises (INPI)</p>
 </div>
 </section>

 {/* Directeur de publication */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">2. Directeur de la publication</h2>
 <p>Le directeur de la publication du site est le représentant légal de STELLARMEET.</p>
 <p className="mt-2">Contact : <a href="mailto:contact@stellarmeet.com" className="text-purple-600 dark:text-purple-400 hover:underline">contact@stellarmeet.com</a></p>
 </section>

 {/* Hébergement */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">3. Hébergement</h2>
 <div className="space-y-4">
 <div className="bg-green-500/10 p-6 rounded-xl border border-green-500/20">
 <p className="font-semibold text-theme-primary mb-2 flex items-center gap-2">
 Backend API (serveur principal) :
 </p>
 <p><strong className="text-theme-primary">Scaleway SAS</strong></p>
 <p>8 rue de la Ville l'Évêque</p>
 <p>75008 Paris, France</p>
 <p className="mt-2">Datacenter : Paris, France </p>
 <p className="mt-2">Site web : <a href="https://www.scaleway.com" target="_blank" rel="noopener noreferrer" className="text-purple-600 dark:text-purple-400 hover:underline">https://www.scaleway.com</a></p>
 <p className="text-sm text-green-200 mt-4">Conformité RGPD garantie - Données hébergées en France</p>
 </div>

 <div className="bg-theme-surface/50 p-6 rounded-xl border border-theme-border">
 <p className="font-semibold text-theme-primary mb-2">Frontend (interface utilisateur) :</p>
 <p><strong className="text-theme-primary">Netlify, Inc.</strong></p>
 <p>44 Montgomery Street, Suite 300</p>
 <p>San Francisco, CA 94104, États-Unis</p>
 <p className="mt-2">Site web : <a href="https://www.netlify.com" target="_blank" rel="noopener noreferrer" className="text-purple-600 dark:text-purple-400 hover:underline">https://www.netlify.com</a></p>
 </div>

 <div className="bg-theme-surface/50 p-6 rounded-xl border border-theme-border">
 <p className="font-semibold text-theme-primary mb-2">Base de données :</p>
 <p><strong className="text-theme-primary">Supabase Inc.</strong></p>
 <p>970 Toa Payoh North, #07-04</p>
 <p>Singapore 318992</p>
 <p className="mt-2">Site web : <a href="https://supabase.com" target="_blank" rel="noopener noreferrer" className="text-purple-600 dark:text-purple-400 hover:underline">https://supabase.com</a></p>
 </div>
 </div>
 </section>

 {/* Propriété intellectuelle */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">4. Propriété intellectuelle</h2>
 <p>L'ensemble des contenus présents sur le site Clairify (textes, images, graphismes, logos, vidéos, icônes, sons, logiciels) est la propriété exclusive de STELLARMEET ou de ses partenaires, sauf mention contraire.</p>
 <p className="mt-4">Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de STELLARMEET.</p>
 <p className="mt-4">Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.</p>
 </section>

 {/* Données personnelles */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">5. Données personnelles</h2>
 <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.</p>
 <p className="mt-4">Pour plus d'informations, consultez notre <Link to="/privacy" className="text-purple-600 dark:text-purple-400 hover:underline">Politique de Confidentialité</Link>.</p>
 <p className="mt-4">Pour exercer vos droits, contactez-nous à : <a href="mailto:privacy@stellarmeet.com" className="text-purple-600 dark:text-purple-400 hover:underline">privacy@stellarmeet.com</a></p>
 </section>

 {/* Cookies */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">6. Cookies</h2>
 <p>Le site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic.</p>
 <p className="mt-4">Pour en savoir plus, consultez notre <Link to="/cookies" className="text-purple-600 dark:text-purple-400 hover:underline">Politique de Cookies</Link>.</p>
 </section>

 {/* Liens hypertextes */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">7. Liens hypertextes</h2>
 <p>Le site peut contenir des liens vers d'autres sites web. STELLARMEET n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.</p>
 <p className="mt-4">La mise en place de liens hypertextes vers le site Clairify nécessite une autorisation préalable écrite de STELLARMEET.</p>
 </section>

 {/* Responsabilité */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">8. Limitation de responsabilité</h2>
 <p>STELLARMEET met tout en œuvre pour offrir aux utilisateurs des informations et/ou outils disponibles et vérifiés, mais ne saurait être tenue responsable des erreurs, d'une absence de disponibilité des informations et/ou de la présence de virus sur son site.</p>
 <p className="mt-4">Les informations fournies par Clairify le sont à titre indicatif et ne sauraient dispenser l'utilisateur d'une analyse complémentaire et personnalisée.</p>
 </section>

 {/* Droit applicable */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">9. Droit applicable et juridiction compétente</h2>
 <p>Les présentes mentions légales sont régies par le droit français.</p>
 <p className="mt-4">En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux compétents de Paris, France.</p>
 </section>

 {/* Mise à jour */}
 <section>
 <h2 className="text-2xl font-semibold text-theme-primary mb-4">10. Mise à jour</h2>
 <p>Les présentes mentions légales peuvent être modifiées à tout moment. Nous vous invitons à les consulter régulièrement.</p>
 <p className="mt-4"><strong className="text-theme-primary">Dernière mise à jour :</strong> 18 janvier 2025</p>
 </section>
 </div>

 {/* Footer links */}
 <div className="mt-12 pt-8 border-t border-theme-border flex flex-wrap gap-4 text-sm">
 <Link to="/terms" className="text-purple-600 dark:text-purple-400 hover:underline">Conditions Générales</Link>
 <Link to="/privacy" className="text-purple-600 dark:text-purple-400 hover:underline">Politique de Confidentialité</Link>
 <Link to="/cookies" className="text-purple-600 dark:text-purple-400 hover:underline">Politique de Cookies</Link>
 </div>
 </article>
 </PublicLayout>
 );
}
